<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.contact_admins") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #f7941e">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <div class="row justify-content-center">
            <div class="col-l2">
              <div class="add_another" @click="addRow()">
                <i class="fas fa-plus"></i>
              </div>
            </div>
            <div
              class="col-lg-6 col-12"
              v-for="(item, index) in mobile"
              :key="'l' + index"
            >
              <div class="item d-flex align-items-center">
                <base-input
                  class="w-100"
                  type="tel"
                  :placeholder="$t('PLACEHOLDERS.phone')"
                  v-model.trim="item.phone"
                />

                <div class="all_actions">
                  <span
                    class="add_another remove_phone_number"
                    @click="removeRow(index)"
                  >
                    <i class="fas fa-minus"></i>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.WhatsApp_contact')"
            v-model.trim="data.WhatsApp_contact"
          />
          <!-- End:: Tax Percentage Input -->

          <!-- Start:: Delivery Price Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
          />
          <!-- End:: Delivery Price Input -->

          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.snap_link')"
            v-model.trim="data.snap"
          />
          <!-- End:: Tax Percentage Input -->

          <!-- Start:: Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.facebook')"
            v-model.trim="data.facebook"
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.instagram')"
            v-model.trim="data.instagram"
          />
          <!-- End:: Input -->

          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.tiktok_link')"
            v-model.trim="data.tiktok_link"
          />
          <!-- End:: Tax Percentage Input -->
          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.youtube_link')"
            v-model.trim="data.youtube_link"
          />
          <!-- End:: Tax Percentage Input -->
          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.x')"
            v-model.trim="data.x"
          />
          <!-- End:: Tax Percentage Input -->
          <!-- Start:: Android  Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.android_link')"
            v-model.trim="data.android_link"
          />
          <!-- End:: Tax Percentage Input -->
          <!-- Start:: Tax Percentage Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.ios_link')"
            v-model.trim="data.ios_link"
          />
          <!-- End:: Tax Percentage Input -->
          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "GeneralSettings",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        WhatsApp_contact: null,
        linkedIn_link: null,
        facebook: null,
        tiktok_link: null,
        youtube_link: null,
        instagram_link: null,
        snapchat: null,
        // youtube: null,
        x: null,
        android: null,
        email: null,
        snap: null,
        facebook: null,
        instagram: null,
        android_link: null,
        ios_link: null,
      },
      // End:: Data Collection To Send

      mobile: [
        {
          phone: "",
        },
      ],
    };
  },

  methods: {
    addRow() {
      this.mobile?.push({ phone: "" });
    },

    removeRow(index) {
      this.mobile.splice(index, 1);
    },

    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `settings?key=contact-us`,
        });
        // Start:: Set Data

        // Transform the API response
        if (res.data.data.data[0].value.mobile) {
          this.mobile = res.data.data.data[0].value.mobile?.map((phone) => ({
            phone: phone,
          }));
        } else {
          this.mobile = [
            {
              phone: "",
            },
          ];
        }

        this.data.WhatsApp_contact = res.data.data.data[0].value.whatsapp;
        // this.data.youtube = res.data.data.data[0].value?.youtube;
        this.data.x = res.data.data.data[0].value?.x;

        this.data.email = res.data.data.data[0].value.email;
        this.data.snap = res.data.data.data[0].value.snapchat;
        this.data.facebook = res.data.data.data[0].value.facebook;
        this.data.instagram = res.data.data.data[0].value.instagram;
        this.data.tiktok_link = res.data.data.data[0].value?.tiktok;
        this.data.youtube_link = res.data.data.data[0].value?.youtube;
        this.data.android_link = res.data.data.data[0].value?.app_store;
        this.data.ios_link = res.data.data.data[0].value?.play_store;
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Edit

    // Start:: Submit Form
    async submitForm() {
      this.isWaitingRequest = !this.isWaitingRequest;

      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("key", "contact-us");
      this.mobile.forEach((element) => {
        if (element.phone) {
          REQUEST_DATA.append(`value[mobile][]`, element.phone);
        }
      });
      if (this.data.WhatsApp_contact) {
        REQUEST_DATA.append("value[whatsapp]", this.data.WhatsApp_contact);
      }
      if (this.data.youtube_link) {
        REQUEST_DATA.append("value[youtube]", this.data.youtube_link);
      }
      if (this.data.email) {
        REQUEST_DATA.append("value[email]", this.data.email);
      }
      if (this.data.tiktok_link) {
        REQUEST_DATA.append("value[tiktok]", this.data.tiktok_link);
      }
      if (this.data.x) {
        REQUEST_DATA.append("value[x]", this.data.x);
      }
      if (this.data.instagram) {
        REQUEST_DATA.append("value[instagram]", this.data.instagram);
      }
      if (this.data.android_link) {
        REQUEST_DATA.append("value[app_store]", this.data.android_link);
      }
      if (this.data.ios_link) {
        REQUEST_DATA.append("value[play_store]", this.data.ios_link);
      }
      // if (this.data.email) {
      //   REQUEST_DATA.append("value[email]", this.data.email);
      // }
      if (this.data.snap) {
        REQUEST_DATA.append("value[snapchat]", this.data.snap);
      }
      if (this.data.facebook) {
        REQUEST_DATA.append("value[facebook]", this.data.facebook);
      }
      // REQUEST_DATA.append("value[linkedin]", this.data.linkedIn_link);

      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `settings`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.submitForm();
    },
    // End:: validate Form Inputs
  },

  created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>

<style lang="scss" scoped>
.item {
  gap: 10px;
}

.all_action {
  display: flex;
  gap: 15px;
}

.add_another {
  border: none;
  padding: 8px;
  width: 40px;
  height: 40px;
  border: 1px solid var(--light_gray_clr);
  border-radius: 50%;
  font-size: 18px;
  color: var(--light_gray_clr);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin: auto;

  .fa-trash {
    color: #ff2159;
    cursor: pointer;
  }
}
</style>
